import { Volume2 } from "lucide-react";
import { speak } from "@/lib/tts";

// Compact card focused on a whole word + picture + tap-to-hear.
// Used in the Basic track page below the alphabet lessons.
export default function WordSoundCard({ item }) {
  const play = () => speak(item.word, { rate: 0.9 });

  return (
    <button
      onClick={play}
      data-testid={`wordsound-card-${item.id}`}
      className="group bg-white rounded-3xl p-6 border-2 border-slate-100 hover:border-sky-200 transition-all shadow-[0_8px_30px_rgb(0,0,0,0.03)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 duration-300 flex flex-col items-center gap-3 w-full text-center"
      aria-label={`Play the word ${item.word}`}
    >
      <div className="text-6xl group-hover:scale-110 transition-transform">
        {item.emoji}
      </div>
      <div className="font-display text-3xl sm:text-4xl font-semibold text-slate-800">
        {item.word}
      </div>
      <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-sky-600 group-hover:text-sky-700">
        <Volume2 className="w-3.5 h-3.5" /> Tap to hear
      </span>
    </button>
  );
}
